export const SET_CURRENT_SCHEDULE_RIDES = 'SET_CURRENT_SCHEDULE_RIDES';

export const actionSetCurrentScheduleRides = schedule_rides => ({
    type: SET_CURRENT_SCHEDULE_RIDES,
    payload: schedule_rides
})
